import React from 'react';

import { Box, Button, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

import IconBox from '../Icons/IconBox';

const Item = (prop) => {
  const activeBg = useColorModeValue('orange.primary', 'blue.secondary');
  const IconColor = useColorModeValue('orange.primary', 'blue.primary');

  return (
    <Box>
      <Link to={prop.path}>
        <Button
          boxSize="initial"
          justifyContent="flex-start"
          alignItems="center"
          bg={activeBg}
          mb={{
            xl: '12px',
          }}
          mx={{
            xl: 'auto',
          }}
          ps={{
            sm: '10px',
            xl: '16px',
          }}
          py="12px"
          borderRadius="15px"
          _hover={{
            bg: 'orange.primary',
            transform: 'none',
            borderColor: 'transparent',
          }}
          w="100%"
          _active={{
            bg: 'orange.primary',
            transform: 'none',
            borderColor: 'transparent',
          }}
          _focus={{
            boxShadow: 'none',
            bg: 'orange.primary',
            transform: 'none',
            borderColor: 'transparent',
          }}
        >
          <Flex>
            <IconBox bg="white" color={IconColor} h="30px" w="30px" me="12px">
              {prop.icon}
            </IconBox>

            {/* <Text color={inactiveColor} my="auto" fontSize="sm"> */}
            <Text my="auto" fontSize="sm">
              {prop.name}
            </Text>
          </Flex>
        </Button>
      </Link>
    </Box>
  );
};

export default Item;
